import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AlertController } from '@ionic/angular';
import { AlertComponent } from '../../components/alert/alert.component';
import { AuthServiceService } from "../../services/auth_services/auth-service.service";
import { StorageServicesService } from '../../services/storage_services/storage-services.service';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {

  resetEmail:string

  constructor(public modalController: ModalController,public auth: AuthServiceService,
    private storageService: StorageServicesService,public alertController: AlertController,public formBuilder: FormBuilder,public translate: TranslateService) { }

  resetForm: FormGroup;

  get errorControl() {
    return this.resetForm.controls;
  }

  ngOnInit() {
    this.resetForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern('[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}')]]
    })
  }

  dismiss() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  onClick_reset(){
    // var accountNo = this.storageService.getLocal("accountNo");

    let alertTitle=''
    let alertDesc=''

    this.translate.get('ALERTS.PIN_RE_SUCC.TITLE').subscribe((res: string) => {
      alertTitle=res;
    });

    this.translate.get('ALERTS.PIN_RE_SUCC.DESC').subscribe((res: string) => {
      alertDesc = res;
    });

    this.auth.forgotPassword(this.resetEmail).subscribe(
      (data) => {
        this.dismiss();
        let alert = new AlertComponent(this.alertController);
        alert.loginSuccessAlert("", alertTitle, alertDesc); 
      },
      (error) => {
        //console.log(error);
      }
    );
  }


}
